<template>
  <div class="request-home">
    <div class="video-container">
      <video id="video" autoplay loop muted>
        <source src="/dist/video/01_about.mp4" type="video/mp4">
        배경화면
      </video>
    </div>
    <div class="welcome-header"></div>
    <div class="welcome" style="z-index:2">
      <div class="box">
        <div class="box-content">
          <div class="ncp-logo">
          </div>
          <p class="welcome-title1">임직원 출입</p>
          <br/>
          <br/>
          <p>
            IDC출입 Am,A,B등급 조직의 임직원은 출입 신청 없이 <br/>입/퇴실 가능합니다.
          </p>
          <br/>
          <br/>
          <div class="box-row">
            <div class="box-label">이름</div>
              <multiselect
                ref="empSelect"
                :value="nameValue"
                v-model="selectedItem"
                :options="empList"
                :custom-label="searchLabel"
                placeholder="임직원검색"
                track-by="empEmail"
                deselect-label="취소"
                select-label="선택"
                :preserve-search="true"
                :searchable="true"
                :internal-search="false"
                :clear-on-select="false"
                @search-change="asyncFind"
              >
                <template slot="singleLabel" slot-scope="{ option }"><div class="single-select-label">{{ option.empName }} [{{option.empTeam}}]</div></template>
                <span slot="noResult">결과가 없습니다.</span>
                <span slot="noOptions">목록이 없습니다.</span>
              </multiselect>
          </div>
          <!--<div class="box-row">-->
            <!--<div class="box-label">이메일</div>-->
            <!--<input  class="box-input" type="text" v-model="item.empEmail"/>-->
          <!--</div>-->
        </div>
        <div class="box-bottom" >
          <div class="lang"><i class="icon-global"></i></div>
          <a class="btn lg white point" @click="goEmployee()">확인</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Vuex from 'vuex';
import Select from '../components/Select.vue';
import Multiselect from 'vue-multiselect'
Vue.use(Vuex);
export default {
  name: "Request",
  components: {
    Select,
    Multiselect
  },
  data(){
    return {
      nameValue: null,
      empList: [],
      selectedItem: null,
      isShow: true
    }
  },
  mounted(){
    this.isShow = true;

  },
  methods: {
    initSearch(){
      //임직원 검색창 초기화
      this.nameValue = null;
      this.selectedItem = null;
      this.empList = [];
      this.$refs.empSelect._data.search = null;

    },
    goEmployee(){

      if(!this.selectedItem) {
        this.noti('오류', '임직원 정보를 확인해주세요.', 'danger');
         return ;
      }

      // var uuid = "3ffb420f-4cba-4c11-a868-91de2ad931c4";
      var steps =  [        //{id: 1, name: this.$t('label.enterTicket'), routeName : 'selectIdc', isSelect: 'on', component: 'SelectTicket'},
        {id: 1, name: this.$t('label.inOutCheckList'), routeName : 'agree', isSelect: '', component: 'Agree'},
        {id: 2, name: this.$t('label.enterInfo'), routeName : 'inputInfo', isSelect: '', component: 'InOutCheckList'},
        //{id: 3, name: this.$t('label.enterInfo'), routeName : 'checkInfo', isSelect: '', component: 'EnterInfo'},
      ]
      this.openModal({view: 'modal/TosCheck', side: false, mode: 'new' , title: '출입 필수사항 확인', data: {steps: steps, data:this.selectedItem, isEmployee: true}, showBottom: false})

      this.initSearch();
    },
    searchLabel ({ empName, empTeam }) {
      return `${empName} [${empTeam}]`
    },
    asyncFind(query){
      if(query == ''){
        this.selectedItem = null;
        this.empList = [];
        return;
      }
      if(query.length < 2) {
        return;
      }
      var that = this;
      this.$http.get('/api/private/emp/abSearch'+'?empName='+ query)
        .then((result) => {
          that.empList = _.uniqBy(result.data, x => x.empEmail);
        }).catch((e) =>{
      })
    },
  }
};
</script>
